import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { showReceiptModal } from '../../actions/modals'
import { fetchReservationsMade } from '../../actions/transactions'

const ReceiptLink = ({
  className,
  children,
  showModal,
  reservation,
  callbackParams,
  fetchReservations
}) => (
  <button
    type="button"
    className={`${className}`}
    onClick={() =>
      showModal({
        show: true,
        reservation,
        modalCallBack: () => {
          // This gets added to Modal object in Redux as a prop. Can then be used
          // to send the user to a previous state, next state and/or close the modal.
          // fetchReservationsMade(callbackParams);
        }
      })
    }
  >
    {children}
  </button>
)

const mapStateToProps = state => ({
  currentUser: state.reduxTokenAuth.currentUser
})

const mapDispatchToProps = dispatch => ({
  showModal: state => dispatch(showReceiptModal(state)),
  fetchReservationMade: params => dispatch(fetchReservationsMade(params))
})
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReceiptLink)
